import { SnippetsLayout } from '../components/UI/AppLayout/SnippetsLayout'

export const SnippetsPage = () => {
    return <SnippetsLayout/>
}
